import { lazy, Suspense } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

// Lazy‑load pages
const HomePage = lazy(() => import('../pages/home/page'));
const LandingPage = lazy(() => import('../pages/landing/page'));
const ProjectHubPage = lazy(() => import('../pages/hub/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const SignInPage = lazy(() => import('../pages/auth/signin/page'));
const SignUpPage = lazy(() => import('../pages/auth/signup/page'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password/page'));
const OnboardingPage = lazy(() => import('../pages/onboarding/page'));
const AuthCallbackPage = lazy(() => import('../pages/auth/callback/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <LandingPage />
      </Suspense>
    ),
  },
  {
    path: '/home',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/hub',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ProtectedRoute>
          <ProjectHubPage />
        </ProtectedRoute>
      </Suspense>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      </Suspense>
    ),
  },
  {
    path: '/auth/signin',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <SignInPage />
      </Suspense>
    ),
  },
  {
    path: '/auth/signup',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <SignUpPage />
      </Suspense>
    ),
  },
  {
    path: '/auth/forgot-password',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ForgotPasswordPage />
      </Suspense>
    ),
  },
  {
    path: '/auth/reset-password',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ResetPasswordPage />
      </Suspense>
    ),
  },
  {
    path: '/auth/callback',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <AuthCallbackPage />
      </Suspense>
    ),
  },
  {
    path: '/onboarding',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <OnboardingPage />
      </Suspense>
    ),
  },
  {
    path: '/404',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <NotFoundPage />
      </Suspense>
    ),
  },
  {
    // Catch‑all route – redirects to the 404 page
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export default routes;
